import React from 'react';

import { Link } from 'react-router-dom';

import { Alert } from '@mui/material';

import CopyableField from '../Common/CopyableField';

import { promoCodePath, promoIdPath } from './promoUrls';

const PromoLink = ({
  codeName,
  promoId,
  title,
  copyValue,
}: {
  codeName?: string;
  promoId?: string;
  title?: string;
  /** Defaults to the identifier, but callers may copy the displayed label instead. */
  copyValue?: string;
}) => {
  if (promoId) {
    return (
      <CopyableField
        value={copyValue ?? promoId}
        label={
          <Link to={promoIdPath(promoId)} target="_blank" rel="noreferrer" color="inherit">
            {title || promoId}
          </Link>
        }
      />
    );
  }
  if (codeName) {
    return (
      <CopyableField
        value={copyValue ?? codeName}
        label={
          <Link to={promoCodePath(codeName)} target="_blank" rel="noreferrer" color="inherit">
            {title || codeName}
          </Link>
        }
      />
    );
  }
  return <Alert severity="error">No promo ID or code name provided</Alert>;
};

export default PromoLink;
